/** Domínio oficial da plataforma de ensinos (produção). */
export const OFFICIAL_APP_URL = "https://ensinos.rechovot.org.br";

/**
 * Domínio customizado ativo no momento (DNS já apontado).
 * Usado enquanto `ensinos.rechovot.org.br` não tem DNS configurado.
 */
export const ACTIVE_CUSTOM_APP_URL = "https://membros.rechovot.org.br";
